import { render, staticRenderFns } from "./ReferralTransactions.vue?vue&type=template&id=f3399a52&scoped=true"
import script from "./ReferralTransactions.vue?vue&type=script&lang=js"
export * from "./ReferralTransactions.vue?vue&type=script&lang=js"
import style0 from "./ReferralTransactions.vue?vue&type=style&index=0&id=f3399a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3399a52",
  null
  
)

export default component.exports